import ProgressiveImage from "@/Components/ProgressiveImage";
import './Curriculum.scss';
import { handleLinkClick } from "@/Utils/routing";

const AboutCurriculum = () => {

    return <div className={"AboutCurriculum"}>
        <ProgressiveImage
            src={"/img/about/curriculum/section_01.jpg"}
            microSrc={"/img/micro/about/curriculum/section_01.jpg"}
            alt={"Curriculum Section 01"}
            width={"100%"}
            aspectRatio={`1050 / 642`}
        />
        <ProgressiveImage
            src={"/img/about/curriculum/section_02.jpg"}
            microSrc={"/img/micro/about/curriculum/section_02.jpg"}
            alt={"Curriculum Section 02"}
            width={"100%"}
            aspectRatio={`1050 / 1557`}
        />
        <ProgressiveImage
            src={"/img/about/curriculum/section_03.jpg"}
            microSrc={"/img/micro/about/curriculum/section_03.jpg"}
            alt={"Curriculum Section 03"}
            width={"100%"}
            aspectRatio={`1050 / 1482`}
        />
        <ProgressiveImage
            src={"/img/about/curriculum/section_04.jpg"}
            microSrc={"/img/micro/about/curriculum/section_04.jpg"}
            alt={"Curriculum Section 04"}
            width={"100%"}
            aspectRatio={`1050 / 1584`}
        />
        <ProgressiveImage
            src={"/img/about/curriculum/section_05.jpg"}
            microSrc={"/img/micro/about/curriculum/section_05.jpg"}
            alt={"Curriculum Section 05"}
            width={"100%"}
            aspectRatio={`1050 / 1758`}
        />
        <ProgressiveImage
            src={"/img/about/curriculum/section_06.jpg"}
            microSrc={"/img/micro/about/curriculum/section_06.jpg"}
            alt={"Curriculum Section 06"}
            width={"100%"}
            aspectRatio={`1050 / 1332`}
        />
        <div className={"UserReview"} style={{ position: "relative", width: "100%" }}>
            <ProgressiveImage
                src={"/img/about/curriculum/section_07.jpg"}
                microSrc={"/img/micro/about/curriculum/section_07.jpg"}
                alt={"Curriculum Section 07"}
                width={"100%"}
                aspectRatio={`1050 / 1275`}
            />
            <div style={{
                position: "absolute", left: 0, bottom: "20%", paddingLeft: "10%", paddingRight: '10%',
                width: "100%",
                display: "flex", alignItems: "center", justifyContent: "space-around",
            }}>
                <a href={"https://www.instagram.com/reel/DR7WrzOExRq"} onClick={handleLinkClick}><img
                    src={"/img/about/curriculum/reels_01.png"} alt={"Reels 01"}
                    style={{ objectFit: 'contain', aspectRatio: '720 / 1280', width: '100%', }}
                /></a>
                <a href={"https://www.instagram.com/reel/DSM8XhDk7Ls"} onClick={handleLinkClick}><img
                    src={"/img/about/curriculum/reels_02.png"} alt={"Reels 02"}
                    style={{ objectFit: 'contain', aspectRatio: '720 / 1280', width: '100%', }}
                /></a>
                <a href={"https://www.instagram.com/reel/DQiIPXNE_qb"} onClick={handleLinkClick}><img
                    src={"/img/about/curriculum/reels_03.png"} alt={"Reels 03"}
                    style={{ objectFit: 'contain', aspectRatio: '720 / 1280', width: '100%', }}
                /></a>
            </div>
        </div>
    </div>;
}

export default AboutCurriculum;